<template>
  <v-footer fixed style="padding: 0; max-width: 100%;" class="fixNotchPaddingBottom">
    <v-row style="margin: 0px; padding: 0px; background-color: #fff;">
      <v-col sm="2" md="2" lg="2" :class="['btn', section == 'home' ? 'selected' : '']" @click="goTo('home')">
        <v-icon>mdi-home</v-icon>
        <span>HOME</span>
      </v-col>
      <v-col sm="2" md="2" lg="2" :class="['btn', section == 'newsletter' ? 'selected' : '']" @click="goTo('newsletter')">
        <v-icon>mdi-email</v-icon>
        <span>NEWSLETTER</span>
      </v-col>
      <v-col sm="2" md="2" lg="2" :class="['btn', section == 'bolsa-trabajo' ? 'selected' : '']" @click="goTo('bolsa-trabajo')">
          <v-icon>mdi-briefcase</v-icon>
        <span>BOLSA</span>
      </v-col>
      <v-col sm="2" md="2" lg="2" :class="['btn', section == 'formacion' ? 'selected' : '']" @click="goTo('formacion')">
        <v-icon>mdi-school</v-icon>
        <span>FORMACIÓN</span>
      </v-col>
      <v-col sm="2" md="2" lg="2" :class="['btn', section == 'tramites' ? 'selected' : '']" @click="goTo('tramites')">
        <v-icon>mdi-view-list</v-icon>
        <span>TRÁMITES</span>
      </v-col>
      <v-col sm="2" md="2" lg="2" :class="['btn', section == 'mas' ? 'selected' : '']" @click="goTo('mas')">
        <v-icon>mdi-dots-vertical</v-icon>
        <span>MÁS</span>
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>

export default {
	name: 'Footer',
	data () {
		return {
			section: null
		}
	},
	mounted() {
		this.section = this.$router.currentRoute.name;
	},
	methods: {
		goTo: function(section) {
			if (this.section == section) {
				return;
			}

			this.$router.push({ name: section });
		}
	},
	watch: {
		$route() {
			this.section = this.$router.currentRoute.name;
		}
	}
}
</script>

<style scoped>
.btn {
  margin: 0;
  padding: 5px;
  text-align: center;
}
.btn i {
  color: #065535;
}
.btn span {
  color: #065535;
  font-size: 8px;
  display: block;
}
.selected i,
.selected span {
  color: #f1b739;
}
</style>